import { Typography } from "@material-ui/core"
import React, { FunctionComponent } from "react"

interface OperationsProgressLabelProps {
    maxOperations: number
    currentOperations: number
}

export const OperationsProgressLabel: FunctionComponent<OperationsProgressLabelProps> = ({
    maxOperations,
    currentOperations
}) => {
    return (
        <Typography
            data-testid="operations-progress-label"
            id="operations-progress-label"
            variant="body1"
        >
            {`${currentOperations} / ${maxOperations}`}
        </Typography>
    )
}
